import { NotificationType } from "@sol/sdk";

const TYPES_SHOWING_SENDER_NAME = [
    NotificationType.FOLLOW_UP_TO_LEARNER,
    NotificationType.GROUP_WORK_TO_LEARNER,
    NotificationType.GROUP_MESSAGE_LEARNER_TO_LEARNER,
];

// With group submission, senders are anonymised behind the trainer label except between learners
export const isSenderShownAsTrainer = (type: NotificationType, isGroupSubmitEnabled: boolean) =>
    isGroupSubmitEnabled && !TYPES_SHOWING_SENDER_NAME.includes(type);
